import React from 'react';
import { Jumbotron, Container } from 'react-bootstrap';

const ViewPrivacyPolicy = () => {
  return (
    <div className="viewPage Hero-banner">
      <Jumbotron className="policy-header">
        <h1>Privacy Policy</h1>
        <p>Last updated: November 10, 2025</p>
      </Jumbotron>

      <Container className="privacy-container">
        <section>
          <h2>1. Overview</h2>
          <p>
            MyLifeClock (“we”, “us”, or “our”) provides tools to help you
            visualize and reflect on your life timeline. This Privacy Policy
            explains how we collect, use, and protect your information when you
            use the MyLifeClock web application and the MyLifeClock iOS app
            (collectively, the “Service”).
          </p>
          <p>
            By using the Service, you agree to the collection and use of
            information in accordance with this Privacy Policy.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Information you provide directly</h3>
          <ul>
            <li>
              <strong>Account information:</strong> When you create an account,
              we collect your email address and password or authentication token.
            </li>
            <li>
              <strong>Profile & life data:</strong> We may collect your date of
              birth and chosen life expectancy to calculate your life timeline.
            </li>
          </ul>

          <h3>2.2 Information collected automatically</h3>
          <ul>
            <li>
              <strong>Usage data:</strong> We may collect data such as pages
              viewed, features used, IP address, and browser type.
            </li>
            <li>
              <strong>Device information:</strong> On iOS, we may collect
              anonymous device data and OS version for performance improvements.
            </li>
          </ul>

          <h3>2.3 No sensitive health data</h3>
          <p>
            MyLifeClock does not collect medical or clinical health data. The
            life expectancy you enter is a personal estimate, not medical
            information.
          </p>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To create and maintain your account.</li>
            <li>To calculate and display your life timeline and widgets.</li>
            <li>To sync data between web and mobile versions.</li>
            <li>To improve and secure the Service.</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing</h2>
          <p>
            We do not sell or rent personal information. We may share limited
            data with trusted service providers that help us operate or secure
            the Service, or when required by law.
          </p>
        </section>

        <section>
          <h2>5. Data Storage and Security</h2>
          <p>
            We use reasonable safeguards to protect your information from
            unauthorized access or disclosure. However, no system is entirely
            secure, and we cannot guarantee absolute protection.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You may request to:</p>
          <ul>
            <li>Access, update, or delete your personal data.</li>
            <li>Deactivate your account at any time.</li>
          </ul>
          <p>
            To make a request, contact us at{' '}
            <strong>support@mylifeclock.io</strong>.
          </p>
        </section>

        <section>
          <h2>7. Children’s Privacy</h2>
          <p>
            MyLifeClock is not intended for children under 13. We do not
            knowingly collect personal data from children.
          </p>
        </section>

        <section>
          <h2>8. Policy Updates</h2>
          <p>
            We may update this Privacy Policy periodically. The revised version
            will be posted here with an updated “Last updated” date. If changes
            are significant, we may notify users by email or app notice.
          </p>
        </section>

        <section>
          <h2>9. Contact</h2>
          <p>
            For any privacy-related questions, contact us at:
            <br />
            <strong>Email:</strong> cody@mylifeclock.io
            <br />
            <strong>Website:</strong> https://www.mylifeclock.io
          </p>
        </section>
      </Container>

      <style jsx>{`
        .policy-header {
          text-align: center;
          padding: 40px 20px;
        }

        .privacy-container {
          max-width: 900px;
          margin: 0 auto 80px auto;
          background-color: #fff;
          color: #222;
          padding: 40px 30px;
          border-radius: 12px;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
          text-align: left; /* 👈 forces all text to align left */
          line-height: 1.7;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
        }

        section {
          margin-bottom: 40px;
        }

        h1 {
          font-size: 2.4rem;
          font-weight: 700;
        }

        h2 {
          font-size: 1.4rem;
          margin-top: 30px;
          font-weight: 600;
          color: #222;
          border-bottom: 2px solid #eee;
          padding-bottom: 6px;
        }

        h3 {
          font-size: 1.1rem;
          margin-top: 18px;
          color: #333;
          font-weight: 500;
        }

        p {
          font-size: 1rem;
          margin-top: 10px;
          margin-bottom: 15px;
        }

        ul {
          margin: 10px 0 15px 25px;
          padding-left: 20px;
          list-style: disc;
        }

        li {
          margin-bottom: 10px;
          text-align: left;
          font-size: 1rem;
        }

        strong {
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .privacy-container {
            padding: 20px;
          }

          h1 {
            font-size: 2rem;
          }

          h2 {
            font-size: 1.2rem;
          }

          p,
          li {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ViewPrivacyPolicy;